import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Lock, ArrowUpRight, FileText, Loader2 } from "lucide-react";
import Navbar from "@/components/Navbar";
import { api, BACKEND_URL } from "@/lib/api";

const src = (t) => (t?.startsWith("/api/") ? `${BACKEND_URL}${t}` : t);

// Public directory of pages published from the Admin "Web Page" tab.
export default function WebPagesDirectory() {
  const [q, setQ] = useState("");
  const [pages, setPages] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.webDirectory(q).then((r) => setPages(r.pages)).catch(() => setPages([])), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="pages-directory">
      <Navbar />
      <div className="mx-auto max-w-4xl px-5 py-12">
        <h1 className="font-display text-4xl font-black tracking-tight sm:text-5xl">Pages</h1>
        <p className="mt-2 text-sm text-[#A1A1AA]">Guides, updates and resources from the Caption Motion team.</p>
        <div className="mt-6 flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 focus-within:border-[#00F0FF]/50">
          <Search size={18} className="text-[#A1A1AA]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search pages…" data-testid="pages-search" className="flex-1 bg-transparent text-sm outline-none placeholder:text-white/30" />
        </div>
        <div className="mt-6 space-y-3" data-testid="pages-list">
          {pages === null && <div className="flex justify-center py-16" data-testid="pages-loading"><Loader2 className="animate-spin text-[#00F0FF]" /></div>}
          {pages?.map((p) => (
            <Link key={p.slug} to={p.url} data-testid={`pages-item-${p.slug}`}
              className="group flex items-stretch gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-3 transition-colors hover:border-[#00F0FF]/40 hover:bg-white/[0.06]">
              <div className="h-24 w-36 shrink-0 overflow-hidden rounded-xl bg-white/5 sm:h-28 sm:w-44">
                {p.thumbnail ? <img src={src(p.thumbnail)} alt="" className="h-full w-full object-cover transition-transform group-hover:scale-105" />
                  : <div className="flex h-full items-center justify-center text-white/20"><FileText size={30} /></div>}
              </div>
              <div className="min-w-0 flex-1 py-1">
                <div className="flex items-center gap-2"><h2 className="truncate text-base font-bold md:text-lg">{p.name}</h2>{p.locked && <span className="flex items-center gap-1 rounded-full bg-[#FFC94D]/15 px-2 py-0.5 text-[10px] font-bold text-[#FFC94D]"><Lock size={10} /> PRO</span>}</div>
                <p className="mt-1 line-clamp-2 text-sm text-[#A1A1AA]">{p.excerpt}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-[#00F0FF]">Open page <ArrowUpRight size={13} /></span>
              </div>
            </Link>
          ))}
          {pages && !pages.length && <p className="py-16 text-center text-sm text-[#A1A1AA]" data-testid="pages-empty">{q ? "No pages match your search." : "No pages published yet."}</p>}
        </div>
      </div>
    </div>
  );
}
